import { OrderStatus } from "@enums";
import { TableCell, Typography } from "@mui/material";
import { toLocaleDateTimeString } from "@utils";
import { useMemo } from "react";

const PrescriptionSubmittedCell = ({
  orderStatus,
  submittedDatetime,
}: {
  orderStatus: string;
  submittedDatetime: string;
}) => {
  const isDraft = orderStatus === OrderStatus.DRAFT;

  const dateTime = useMemo(() => {
    if (isDraft || !submittedDatetime) {
      return null;
    }

    const _dateTimeString = toLocaleDateTimeString(submittedDatetime);
    const date = _dateTimeString.split(",")[0];
    const time = _dateTimeString.split(",")[1];
    return { date, time };
  }, [submittedDatetime, isDraft]);

  return (
    <TableCell sx={{ minWidth: "160px" }}>
      {dateTime && (
        <>
          <Typography variant="body2">{dateTime.date}</Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {dateTime.time}
          </Typography>
        </>
      )}
      {!dateTime && isDraft && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontStyle: "italic",
          }}
        >
          Draft
        </Typography>
      )}
    </TableCell>
  );
};

export default PrescriptionSubmittedCell;
